import { useCallback } from 'react';
import { betStore, notificationStore, userInfoStore } from '@pascal/pascal-core';
import { autoPlayBetStore, doBetStore, gameStore, manualBetStore } from '../store';
import { defaultMinOdd } from '../enums/gameConstants';

export const useDemoSwitcher = () => {
  const demoSwitcherAdditionalFunction = useCallback(() => {
    const { partnerWageringOdd, setMinOdd, setDefaultMinOdd } = gameStore;
    const realAllBets = betStore.liveBets.filter((bet) => bet.playerExternalId);
    betStore.setLiveBets([...realAllBets]);
    autoPlayBetStore.resetAutoplayData();
    autoPlayBetStore.setIsAutoPlayMode();
    autoPlayBetStore.setAutoBetAccepted(false);
    manualBetStore.resetDemoSwitcher();
    doBetStore.handleBetForNextRound();
    doBetStore.resetDoBetStore();
    userInfoStore.setDemoInitialBalance();
    notificationStore.setNotificationType({});

    if (partnerWageringOdd) {
      setMinOdd(partnerWageringOdd);
      if (partnerWageringOdd > defaultMinOdd) {
        setDefaultMinOdd(partnerWageringOdd);
        autoPlayBetStore.changeAutoPlayInitialAutoCashOutOdd(partnerWageringOdd);
        autoPlayBetStore.setAutoPlayAutoCashOutOdd(partnerWageringOdd);
        manualBetStore.changeInitialDataAutoCashOutOdd(partnerWageringOdd);
        manualBetStore.setManualDefaultAutoCashOutOdd(partnerWageringOdd);
      }
    }

    const realMyBets = realAllBets.filter(
      (bet) => bet.playerExternalId === userInfoStore.playerExternalId
    );

    doBetStore.setCurrentInitialAndRealModeData(realMyBets);
  }, []);

  return { demoSwitcherAdditionalFunction };
};
